import EmployeeOverview from './EmployeeOverview.vue';
import EmployeeHeader from './EmployeeHeader.vue';
import moduleId from './moduleId';
import Employee from '@/modules/employee/Employee.vue';

export const ROUTE_EMPLOYEE_OVERVIEW = 'ROUTE_EMPLOYEE_OVERVIEW';
export const ROUTE_EMPLOYEE = 'ROUTE_EMPLOYEE';

class EmployeeRouteHandler {
  getRoutes = ({ moduleType }) => {
    const initiateSyncBeforeNav = true;
    return [
      {
        name: ROUTE_EMPLOYEE,
        path: '/employee/:employeeId',

        meta: {
          moduleType,
          initiateSyncBeforeNav,
          moduleId,
          baseRoute: true,
          backPath: (currentRouteParams) => {
            console.debug('getBackPath');
            return `/employee`;
          },
        },

        components: { default: Employee, header: EmployeeHeader },
      },

      {
        path: '/employee',
        name: ROUTE_EMPLOYEE_OVERVIEW,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },

        components: { default: EmployeeOverview, header: EmployeeHeader },
      },
    ];
  };
}

const routeHandler = new EmployeeRouteHandler();
export default routeHandler;
